




























































































import { Component, PropSync, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import ModalLocation from '@/components/manageGroup/locations/ModalLocation.vue';

import * as s_Interface from '@/interface/store/manageGroups';

const namespace: string = 'manageGroup';

@Component({
  components: {
    ModalLocation,
  },
})
export default class Locations extends Vue {
  @PropSync('dialogVisible', { type: Boolean }) syncedDialogVisible!: boolean;

  @Action('getMainLocations', { namespace }) c_getMainLocations!: any;
  @Action('getSubLocations', { namespace }) c_getSubLocations!: any;
  @Action('deleteMainLocation', { namespace }) c_deleteMainLocation!: any;
  @Action('deleteSubLocation', { namespace }) c_deleteSubLocation!: any;
  @Action('updateMainLocation', { namespace }) c_updateMainLocation!: any;

  @Getter('getterMainLocations', { namespace }) c_getterMainLocations!: Array<
    s_Interface.MainLocationData
  >;
  @Getter('getterSubLocations', { namespace }) c_getterSubLocations!: Array<
    s_Interface.SubLocationData
  >;

  public locationValue: string = '';
  public mainLocationName: string = '';
  public mainLocationId: string = '';
  public subLocationId: string = '';
  public locationMode: string = 'main';
  public updateOn: boolean = false;

  get locationName(): string {
    return this.locationValue;
  }

  set locationName(v: string) {
    this.locationValue = v;
  }

  get searchList(): Array<s_Interface.MainLocationData> {
    let matchTextArray: any = null;
    const matcher = new RegExp(this.locationName.replace(/[\\^$.|?*+()[{]/g, '\\$&'));
    this.locationName === ''
      ? (matchTextArray = this.c_getterMainLocations)
      : (matchTextArray = this.c_getterMainLocations.filter((v: any) => {
          if (matcher.test(v.name)) return v;
        }));
    return matchTextArray;
  }

  updateOnChange() {
    this.updateOn = !this.updateOn;
  }

  async created() {
    const groupId: string = this.$route.params.groupId;
    try {
      if (!this.c_getterMainLocations.length) await this.initGetLocation();
      if (this.c_getterMainLocations.length > 0) {
        this.mainLocationId = this.c_getterMainLocations[0].id;
        this.mainLocationName = this.c_getterMainLocations[0].name;
        await this.c_getSubLocations({ groupId, locationId: this.mainLocationId });
      }
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  @Watch('$route.params.groupId')
  async onGroupIdChange(groupId: string, oldGroupId: string) {
    try {
      await this.initGetLocation();
      if (this.c_getterMainLocations.length > 0) {
        this.mainLocationId = this.c_getterMainLocations[0].id;
        this.mainLocationName = this.c_getterMainLocations[0].name;
        await this.c_getSubLocations({ groupId, locationId: this.mainLocationId });
      }
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  async entranceSubLocation(item: s_Interface.MainLocationData): Promise<any> {
    const groupId: string = this.$route.params.groupId;
    this.mainLocationName = item.name;
    this.mainLocationId = item.id;
    try {
      await this.c_getSubLocations({
        groupId,
        locationId: item.id,
      });
      this.updateOn = true;
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  async initGetLocation(): Promise<any> {
    await this.c_getMainLocations(this.$route.params.groupId);
  }

  addLocationOpen(mode: string, subId?: string) {
    this.syncedDialogVisible = true;
    this.locationMode = mode;
    this.locationValue = '';
    if (subId !== undefined) this.subLocationId = subId;
  }

  onModalClose(bool: boolean) {
    this.syncedDialogVisible = bool;
  }

  async updateMainLocation(e: any): Promise<any> {
    try {
      const locationId = this.mainLocationId;
      const groupId: string = this.$route.params.groupId;
      const name = e.target.value;
      await this.c_updateMainLocation({
        groupId,
        locationId,
        payload: {
          name,
        },
      });
      await this.initGetLocation();
      this.$message.success('보관위치명을 변경하였습니다.');
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  async deleteMainLocation(location: s_Interface.MainLocationData): Promise<any> {
    const groupId: string = this.$route.params.groupId;
    this.$confirm(
      '보관위치를 삭제해도 물품은 삭제되지 않습니다.',
      `'${location.name}' 보관위치를 삭제하시겠습니까?`,
      {
        confirmButtonText: '보관위치 삭제',
        cancelButtonText: '취소',
        type: 'warning',
      }
    )
      .then(async () => {
        try {
          await this.c_deleteMainLocation({
            groupId,
            locationId: location.id,
          });

          await this.initGetLocation();
          if (this.c_getterMainLocations.length === 0) this.mainLocationName = '';
          else {
            this.mainLocationName = this.c_getterMainLocations[0].name;
          }
          if (this.c_getterMainLocations.length > 0) {
            this.mainLocationId = this.c_getterMainLocations[0].id;
            await this.c_getSubLocations({ groupId, locationId: this.mainLocationId });
          }
          this.$message.success(`'${location.name}'보관위치를 삭제하였습니다.`);
        } catch (e) {
          console.log(e);
          this.$message.error(e.response.data.error.message);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async deleteSubLocation(item: any): Promise<any> {
    const groupId: string = this.$route.params.groupId;
    this.$confirm(`'${item.name}'을 삭제하시겠습니까?`, '세부위치 삭제', {
      confirmButtonText: '세부위치 삭제하기',
      cancelButtonText: '취소',
      type: 'warning',
    })
      .then(async () => {
        try {
          await this.c_deleteSubLocation({
            groupId,
            locationId: this.mainLocationId,
            subId: item.id,
          });
          await this.c_getSubLocations({ groupId, locationId: this.mainLocationId });
          this.$message.success(`'${item.name}'세부위치를 삭제하였습니다.`);
        } catch (e) {
          console.log(e);
          this.$message.error(e.response.data.error.message);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async onAddSubmit({ isShow, locationId }: { isShow: boolean; locationId: string }): Promise<any> {
    try {
      await this.initGetLocation();
      const groupId: string = this.$route.params.groupId;

      this.syncedDialogVisible = isShow;

      if (this.locationMode === 'main') {
        await this.entranceSubLocation(this.c_getterMainLocations[0]);
      } else {
        this.mainLocationId = locationId;
        this.mainLocationName = this.c_getterMainLocations.filter(
          (v: s_Interface.MainLocationData) => v.id === locationId
        )[0].name;
        await this.c_getSubLocations({ groupId, locationId });
      }
      switch (this.locationMode) {
        case 'main':
          this.$message.success('보관위치를 추가하였습니다.');
          break;
        case 'sub':
          this.$message.success('세부위치를 추가하였습니다.');
          break;
        case 'subModify':
          this.$message.success('세부위치 이름을 변경하였습니다.');
          break;
      }
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }
}
